import { handleActions } from 'redux-actions'

import {
  setActiveClinicianUsers,
  setClinicianUsers,
  setCreateCallLoading,
  setModalVisibility,
  setPatientsListWithDevice,
  setScheduledItems,
  setScheduledItemsLoading,
  setSchedulerModalVisibility,
  setWaitingRoomCount
} from 'src/store/modules/actions/telehealth'

const initialState = {
  meetingSessionInstance: null,
  scheduledItems: [],
  scheduledItemsLoading: false,
  createCallLoading: false,
  clinicianUsers: [],
  activeClinicianUsers: [],
  waitingRoomCount: {
    scheduled: 0,
    waiting: 0
  },
  patientsListWithDevice: [],
  isModalVisible: false,
  isSchedulerModalVisible: false
}

export default handleActions(
  {
    [setScheduledItems](state, { payload: scheduledItems }) {
      return {
        ...state,
        scheduledItems
      }
    },
    [setScheduledItemsLoading](state, { payload: scheduledItemsLoading }) {
      return {
        ...state,
        scheduledItemsLoading
      }
    },
    [setCreateCallLoading](state, { payload: createCallLoading }) {
      return {
        ...state,
        createCallLoading
      }
    },
    [setClinicianUsers](state, { payload: clinicianUsers }) {
      return {
        ...state,
        clinicianUsers
      }
    },
    [setWaitingRoomCount](state, { payload: waitingRoomCount }) {
      return {
        ...state,
        waitingRoomCount
      }
    },
    [setActiveClinicianUsers](state, { payload: activeClinicianUsers }) {
      return {
        ...state,
        activeClinicianUsers
      }
    },
    [setPatientsListWithDevice](state, { payload: patientsListWithDevice }) {
      return {
        ...state,
        patientsListWithDevice
      }
    },
    [setModalVisibility](state, { payload: isModalVisible }) {
      return {
        ...state,
        isModalVisible
      }
    },
    [setSchedulerModalVisibility](state, { payload: isSchedulerModalVisible }) {
      return {
        ...state,
        isSchedulerModalVisible
      }
    }
  },
  initialState
)
